import fdpHelper from '../../FDPhelper';
var fdpHelperV2 = null;
var getFDPHelperV2 = function () {
    if (!fdpHelperV2) {
        try {
            fdpHelperV2 = require('../../FDPHelperV2').default;
        }
        catch (e) {
            // FDPHelperV2 not available, will fallback to FDPhelper
        }
    }
    return fdpHelperV2;
};
var FDPDwellLogger = /** @class */ (function () {
    function FDPDwellLogger() {
    }
    FDPDwellLogger.prototype.logDwellInfo = function (dwellObject, dwellTime) {
        // Use pre-calculated dwell time if provided, otherwise calculate it
        var calculatedDwellTime = dwellTime !== undefined
            ? dwellTime
            : dwellObject.endTime - dwellObject.startTime - dwellObject.inactivityTime;
        if (!isFinite(calculatedDwellTime) || calculatedDwellTime <= 0) {
            return;
        }
        var eventName = 'DTCE';
        var fieldMapping = {
            startTime: 'st',
            endTime: 'et',
            parentImpressionId: 'piid',
            pageType: 'pt',
            widgetType: 'wtp',
            widgetViewType: 'wvt',
            widgetCategory: 'wct',
            moduleId: 'mid',
            contentType: 'ctp',
            type: 'tp',
            widgetTitle: 'wtl',
            inactivityTime: 'it'
        };
        var dwellEvent = {
            en: eventName,
            st: dwellObject.startTime,
            et: dwellObject.endTime,
            dt: calculatedDwellTime,
            it: dwellObject.inactivityTime,
            t: Date.now()
        };
        var dwellObjectKeys = [
            'parentImpressionId', 'pageType', 'widgetType', 'widgetViewType',
            'widgetCategory', 'moduleId', 'contentType', 'type', 'widgetTitle'
        ];
        dwellObjectKeys.forEach(function (key) {
            var value = dwellObject[key];
            if (value !== undefined && value !== null) {
                var mappedKey = fieldMapping[key] || key;
                dwellEvent[mappedKey] = value;
            }
        });
        Object.keys(dwellEvent).forEach(function (key) {
            if (dwellEvent[key] === undefined) {
                delete dwellEvent[key];
            }
        });
        this.validatePayloadStructure(dwellEvent);
        try {
            var fdpV2 = getFDPHelperV2();
            if (fdpV2 && typeof fdpV2.trackEvent === 'function') {
                fdpV2.trackEvent(dwellEvent);
                return;
            }
            fdpHelper.trackEvent(dwellEvent, true);
        }
        catch (error) {
            console.error('[DwellTime] Error tracking DTCE event:', error);
        }
    };
    FDPDwellLogger.prototype.validatePayloadStructure = function (event) {
        var requiredFields = ['st', 'et', 'dt', 'en', 't'];
        var missingFields = [];
        requiredFields.forEach(function (field) {
            if (event[field] === undefined || event[field] === null) {
                missingFields.push(field);
            }
        });
        if (missingFields.length > 0) {
            console.error('[DwellTime] Validation failed - Missing required fields:', missingFields);
        }
    };
    return FDPDwellLogger;
}());
export default FDPDwellLogger;
